module.exports = __webpack_public_path__ + "static/media/multipangpang.e8816b68.png";